import { DatePicker, TimePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { DateTime } from 'luxon';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface CancellationErrorPracticeVM {
  closureDate?: DateTime | null;
  closureTime?: DateTime | null;
  closureReason?: string;
}

interface AccordionErrorClosurePracticeFormProps {
  disabled?: boolean;
  values?: CancellationErrorPracticeVM;
  errors?: FormikErrors<CancellationErrorPracticeVM>;
  touched?: FormikTouched<CancellationErrorPracticeVM>;
  onChange: (
    key: keyof CancellationErrorPracticeVM,
    value: CancellationErrorPracticeVM[keyof CancellationErrorPracticeVM]
  ) => void;
}

const AccordionErrorClosurePracticeFormComponent = ({
  disabled,
  values,
  onChange,
  touched,
  errors,
}: AccordionErrorClosurePracticeFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <DatePicker
          label="Data chiusura *"
          aria-label="Data chiusura"
          value={values?.closureDate || null}
          onChange={(date) => onChange('closureDate', date)}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="closureDate"
              fullWidth
              error={touched?.closureDate && Boolean(errors?.closureDate)}
              helperText={errors?.closureDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora chiusura *"
          value={values?.closureTime || null}
          onChange={(date) => {
            onChange('closureTime', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="closureTime"
              {...params}
              fullWidth
              error={touched?.closureTime && Boolean(errors?.closureTime)}
              helperText={errors?.closureTime}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="closureReason"
          label="Motivo chiusura*"
          aria-label="motivo"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '100',
          }}
          onChange={(event) => {
            onChange('closureReason', event.target.value);
          }}
          value={values?.closureReason || ''}
          error={touched?.closureReason && Boolean(errors?.closureReason)}
          helperText={errors?.closureReason}
        />
      </Grid>
    </Grid>
  );
};

AccordionErrorClosurePracticeFormComponent.displayName =
  'Accordion error closure practice form component';

const AccordionErrorClosurePracticeForm = memo(AccordionErrorClosurePracticeFormComponent);

export default AccordionErrorClosurePracticeForm;
